<template>
  <wine-component/>
</template>

<script>
import WineComponent from '@/spa/components/board/wine/product/BoardWine';

export default {
  name: 'WinePage',
  components: {
    WineComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/pages/contents/wine/WinePage.vue